import type { Match } from './types';

export const matches: Match[] = [
  {
    id: 'match-1',
    homeTeam: '皇家马德里',
    awayTeam: '巴塞罗那',
    homeScore: 2,
    awayScore: 1,
    status: 'live',
    league: '西甲联赛',
    time: '75\'',
    category: 'football',
  },
  {
    id: 'match-2',
    homeTeam: '湖人',
    awayTeam: '勇士',
    homeScore: 98,
    awayScore: 102,
    status: 'live',
    league: 'NBA常规赛',
    time: 'Q4 3:25',
    category: 'basketball',
  },
  {
    id: 'match-3',
    homeTeam: '德约科维奇',
    awayTeam: '阿尔卡拉斯',
    homeScore: 2,
    awayScore: 1,
    status: 'live',
    league: 'ATP大师赛',
    time: '第三盘 4-3',
    category: 'tennis',
  },
  {
    id: 'match-4',
    homeTeam: '曼城',
    awayTeam: '阿森纳',
    homeScore: null,
    awayScore: null,
    status: 'upcoming',
    league: '英超联赛',
    time: '今日 22:00',
    category: 'football',
  },
  {
    id: 'match-5',
    homeTeam: '凯尔特人',
    awayTeam: '雄鹿',
    homeScore: null,
    awayScore: null,
    status: 'upcoming',
    league: 'NBA季后赛',
    time: '明日 08:30',
    category: 'basketball',
  },
  {
    id: 'match-6',
    homeTeam: 'T1',
    awayTeam: 'GEN',
    homeScore: 2,
    awayScore: 0,
    status: 'finished',
    league: 'LCK夏季赛',
    time: '已结束',
    category: 'esports',
  },
  {
    id: 'match-7',
    homeTeam: '维斯塔潘',
    awayTeam: '汉密尔顿',
    homeScore: null,
    awayScore: null,
    status: 'upcoming',
    league: 'F1英国大奖赛',
    time: '本周末 21:00',
    category: 'racing',
  },
  {
    id: 'match-8',
    homeTeam: '张伟丽',
    awayTeam: '罗斯',
    homeScore: null,
    awayScore: null,
    status: 'upcoming',
    league: 'UFC女子草量级',
    time: '下周日 10:00',
    category: 'combat',
  },
];